export default __webpack_public_path__ + "static/13-4d25cef7368aa9d952019ea29becce9b.jpg";